import { setCrewDailyChallengePending } from './crewDailyChallenge';

export async function crewChallengeVoteNow({
  supabase,
  crewsAtRisk,
  navigate,
  setView,
  setShowSettingsPanel,
}) {
  const firstCrew = crewsAtRisk?.[0] || null;
  if (firstCrew) setCrewDailyChallengePending(firstCrew);

  try {
    const { data, error } = await supabase.rpc('get_my_crews_vote_now_target');
    if (error) throw error;
    if (!data?.ok) throw new Error(data?.reason || 'vote_target_failed');

    if (data.target_type === 'daily') {
      setView('home');
      setTimeout(() => {
        try {
          document.getElementById('home-daily-decision')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch {}
      }, 50);
      return;
    }

    if (data.target_type === 'trial' && data.trial_id) {
      navigate(`/t/${data.trial_id}`);
      return;
    }

    if (data.crew_id) {
      navigate(`/crew/${data.crew_id}`);
      return;
    }

    setShowSettingsPanel(true);
  } catch (err) {
    console.warn('[crew-challenge] vote_now_target_failed', { error: err?.message || String(err) });
    setShowSettingsPanel(true);
  }
}
